import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/DoneRounded';

class DoneIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default DoneIcon;
